export const BundleProductSpecificationsIdentifier = {
  SI_INTERNET: 'si_internet',
  SI_TV: 'si_tv',
  SI_LANDLINE: 'si_landline',
};

export default BundleProductSpecificationsIdentifier;
